import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import DaysForecast from './pages/DaysForecast';
import HighRisk from './pages/HighRisk';
import Live from './pages/Live';
import GameHistory from './pages/GameHistory';
import Posts from './pages/Posts';
import AboutUs from './pages/AboutUs';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ticketUpdateService from './services/ticketUpdateService';
import './App.css';

function App() {
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    // Start automatic ticket updates after a small delay to ensure Firebase is ready
    const initializeApp = async () => {
      try {
        console.log('🚀 App initializing...');
        // Give Firebase time to initialize
        await new Promise(resolve => setTimeout(resolve, 500));
        console.log('✅ App ready!');
        
        // Start automatic ticket updates
        ticketUpdateService.startAutoUpdate(5); // Update every 5 minutes
      } catch (error) {
        console.error('❌ Error initializing app:', error);
        setLoadError(error.message);
      }
    };

    initializeApp();

    // Cleanup on unmount
    return () => {
      ticketUpdateService.stopAutoUpdate();
    };
  }, []);

  if (loadError) {
    console.error('App Load Error:', loadError);
    // App still renders, but logs error for debugging
  }

  return (
    <Router>
      <div className="App">
        <Navigation />
        <PWAInstallPrompt />

        
        <main className="main-content">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Routes>
              <Route path="/" element={<DaysForecast />} />
              <Route path="/days-forecast" element={<DaysForecast />} />
              <Route path="/winaswari-prognozi" element={<HighRisk />} />
              <Route path="/high-risk" element={<Navigate to="/winaswari-prognozi" replace />} />
              <Route path="/live" element={<Live />} />
              <Route path="/history" element={<GameHistory />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/shesvla" element={<AdminLogin />} />
              <Route path="/shesvla/dashboard" element={<AdminDashboard />} />
            </Routes>
          </motion.div>
        </main>

        {/* Developer Credit - Global Footer */}
        <motion.div 
          className="developer-credit"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <p>Developed by <a href="https://www.shota.in" target="_blank" rel="noopener noreferrer">Shota Iasashvili</a></p>
        </motion.div>
      </div>
    </Router>
  );
}

export default App;
